import JobService from "../services/JobService";

export default {
    computed: {
        customerIdParam() {
            return this.$route.query.customer_id;
        },
        jobIdParam() {
            return this.$route.query.job_id;
        },
    },

    methods: {
        populateFormFromRouteQuery() {
            if (this.customerIdParam) {
                this.form.customer_id = this.customerIdParam;
            }

            this.onCustomerIdSetFromRoute();

            if (this.jobIdParam) {
                this.loadFormJobFromRoute(this.jobIdParam);
            }
        },

        loadFormJobFromRoute(jobId) {
            this.form.job_id = jobId;

            return JobService.get(jobId).then(res => {
                this.applyJobToForm(res.data);
                this.onJobLoadedFromRoute(res.data);
                return res.data;
            });
        },

        applyJobToForm(jobData) {
            this.form.customer = jobData.customer;
            this.form.customer_id = jobData.customer_id;
            this.form.site = jobData.site;
            this.form.site_id = jobData.site_id;
        },

        onCustomerIdSetFromRoute() {
            // Override in components that need extra handling when only customer_id is present.
        },

        onJobLoadedFromRoute() {
            if (typeof this.getJobs === 'function') {
                this.getJobs();
            }
        },
    },
};

export const formRouteQueryWatchers = {
    customerIdParam: {
        handler(customerId) {
            if (customerId) {
                this.form.customer_id = customerId;
            }
        },
        immediate: true,
    },
    jobIdParam: {
        handler(jobId) {
            if (!jobId) {
                return;
            }

            this.loadFormJobFromRoute(jobId);
        },
        immediate: true,
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/UsesFormRouteQuery.js